export default __webpack_public_path__ + "static/web/media/cyber-security.9bbb0f6f.jpg";